import { SCREENSAVER_MODE } from '../actionConstants';
import defaultState from './screensaverDefaultState';
import { Screensaver, ScreensaverMode } from './screensaverTypes';
import { Action } from '../../generalTypes';

export default (
  state: Screensaver = defaultState,
  action: Action<ScreensaverMode>
): Screensaver => {
  switch (action.type) {
    case SCREENSAVER_MODE:
      return {
        mode: action.payload,
      };
    default:
      return state;
  }
};
